import req from "@/assets/js/axios"

export default {
    // 获取灵感面料
    getMaterials: (params) => {
        return req.apiAxios('POST', '/material/MaterialController/getMaterials', params)
    }
}
